import { request } from "@/api/request"

/** 项目列表 */
export function fetchProjectList(payload = {}) {
  return request.post("/mgm-crm-api/project/query", payload).then(r => r.data)
}

/** 新增项目 */
export function createProject(payload = {}) {
  return request.post("/mgm-crm-api/project/create", payload).then(r => r.data)
}

/** 编辑项目 */
export function updateProject(payload = {}) {
  return request.post("/mgm-crm-api/project/update", payload).then(r => r.data)
}

/** 删除项目 */
export function deleteProject(id) {
  return request.post(`/mgm-crm-api/project/delete/${id}`, {}).then(r => r.data)
}
